import styled from '../../../../../styles/legacy/styled/styled'

export const ModalActions = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  margin: 0 40px 40px;
`
